module.exports = __webpack_public_path__ + "img/bsd.e4308e1d.png";